import API_URLS from "@/constants/apiUrls";
import { HTTP_METHODS } from "@/constants/httpMethods";
import { request } from "@/lib/api";

export const pointConvertService = {
  pointInquiryNewCard: (payload = {}, headers = {}, hasErrorHandler = false) =>
    request({
      method: HTTP_METHODS.POST,
      url: API_URLS.pointConvert.pointInquiryNewCard,
      payload,
      headers,
      hasErrorHandler,
    }),
  pointInquirySavedCard: (
    payload = {},
    headers = {},
    hasErrorHandler = false,
  ) =>
    request({
      method: HTTP_METHODS.POST,
      url: API_URLS.pointConvert.pointInquirySavedCard,
      payload,
      headers,
      hasErrorHandler,
    }),
  pointConvertWithNewCard: (
    payload = {},
    headers = {},
    hasErrorHandler = false,
  ) =>
    request({
      method: HTTP_METHODS.POST,
      url: API_URLS.pointConvert.pointConvertWithNewCard,
      payload,
      headers,
      hasErrorHandler,
    }),
  pointConvertWithSavedCard: (
    payload = {},
    headers = {},
    hasErrorHandler = false,
  ) =>
    request({
      method: HTTP_METHODS.POST,
      url: API_URLS.pointConvert.pointConvertWithSavedCard,
      payload,
      headers,
      hasErrorHandler,
    }),

  completePointConvertPaymentNewCard: (
    payload = {},
    headers = {},
    hasErrorHandler = false,
  ) =>
    request({
      method: HTTP_METHODS.POST,
      url: API_URLS.pointConvert.completePointConvertPaymentNewCard,
      payload,
      headers,
      hasErrorHandler,
    }),
  completePointConvertPaymentSavedCard: (
    payload = {},
    headers = {},
    hasErrorHandler = false,
  ) =>
    request({
      method: HTTP_METHODS.POST,
      url: API_URLS.pointConvert.completePointConvertPaymentSavedCard,
      payload,
      headers,
      hasErrorHandler,
    }),
  periodConversion: (payload = {}, headers = {}, hasErrorHandler = false) =>
    request({
      method: HTTP_METHODS.POST,
      url: API_URLS.pointConvert.periodConversion,
      payload,
      headers,
      hasErrorHandler,
    }),
  sendSaveCardOTP: (payload = {}, headers = {}, hasErrorHandler = false) =>
    request({
      method: HTTP_METHODS.POST,
      url: API_URLS.pointConvert.sendSaveCardOTP,
      payload,
      headers,
      hasErrorHandler,
    }),
  verifySaveCardOTP: (payload = {}, headers = {}, hasErrorHandler = false) =>
    request({
      method: HTTP_METHODS.POST,
      url: API_URLS.pointConvert.verifySaveCardOTP,
      payload,
      headers,
      hasErrorHandler,
    }),
};
